<template>
  <div>{{ getRole ? getRole.label : '-' }}</div>
</template>

<script>
export default {
  props: {
    privilege: {
      type: [String, Object],
      required: true
    }
  },
  computed: {
    getRole() {
      const privilege =
        typeof this.privilege === 'string' ? JSON.parse(this.privilege) : this.privilege
      if (privilege && Object.hasOwnProperty.call(privilege, 'role')) {
        const role = this.$store.getters.ticketRoleOptions.find((role) => {
          return role.value === privilege.role
        })
        if (role) {
          return role
        }
        if (['superadmin'].includes(privilege.role)) {
          return {
            label: 'Super admin'
          }
        }
        if (['systemadmin'].includes(privilege.role)) {
          return {
            label: 'System admin'
          }
        }
        return privilege.role
      } else {
        return undefined
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/user/UserRole.vue